export default "__VITE_ASSET__CYkOAbe9__"